export default {
	removePlugins: [ 
		'CKFinderUploadAdapter',
		'MediaEmbed',
		'ImageUpload',
	],
	toolbar: [
		"heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "insertTable", "undo", "redo"
	],
}
